module.exports = __webpack_public_path__ + "img/transfer-pay.3afcaefb.svg";